import React from 'react';
import { Box, Typography } from '@mui/material';

import { useSelectedSlideInfoStyles } from 'components/SlideGroups/utilities/styles';

export const SelectedSlideInfo = ({
  selectedCount,
  totalCount,
  children = '',
  className = '',
}) => {
  const { classes } = useSelectedSlideInfoStyles();

  return (
    <Box className={`${classes.root} ${className}`}>
      <Typography className={classes.selectedText}>
        {!!totalCount && (
          <>
            Slides Selected :{' '}
            <span>
              {selectedCount}/{totalCount}
            </span>
          </>
        )}
      </Typography>
      {children}
    </Box>
  );
};
